export default __webpack_public_path__ + "static/screenshot7-3526a17b6ceb7498916bd7ef8a85bd1a.jpg";